import {Injectable} from '@angular/core';

@Injectable()
export class Helper {
  static capitalize(string: any) {
    string = string.toLowerCase();
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  static capitalizeFirstWord(string: any) {
    let splitStr = string.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  }

  static removeObject(arr, attr, value) {
    let i = arr.length;
    while (i--) {
      if (arr[i]
        && arr[i].hasOwnProperty(attr)
        && (arguments.length > 2 && arr[i][attr] === value)) {
        arr.splice(i, 1);
      }
    }
    return arr;
  }

  static mapTwoArrays(primaryArr, secondaryArr, primaryArrkey, secondaryArrKey, statusKey) {
    if (primaryArr && primaryArr.length > 0) {
      primaryArr.forEach((item: any) => {
        item[statusKey] = false;
        if (secondaryArr && secondaryArr.length > 0) {
          secondaryArr.forEach((dt: any) => {
            if (dt && dt[secondaryArrKey] == item[primaryArrkey]) {
              item[statusKey] = true;
            }
          });
        }
      });
      return primaryArr;
    } else {
      return [];
    }
  }

  static updateArray(primaryArr, changedArr, id) {
    if (primaryArr && primaryArr.length > 0) {
      primaryArr.forEach((items: any, key: any) => {
        if (items.id === id) {
          for (const obj in changedArr) {
            primaryArr[key][obj] = changedArr[obj];
          }
        }
      });
    }
    return primaryArr;
  }

  static formatDate(date: any): any {
    let d: any = new Date(date),
      month: any = '' + (d.getMonth() + 1),
      day: any = '' + d.getDate(),
      year: any = d.getFullYear();
    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    return [year, month, day].join('-');
  }

  static formatDateTime(date: any): string {
    let d: Date = new Date(date);
    let year: number = d.getFullYear();
    let month: string = (d.getMonth() + 1).toString().padStart(2, '0');
    let day: string = d.getDate().toString().padStart(2, '0');
    let hours: string = d.getHours().toString().padStart(2, '0');
    let minutes: string = d.getMinutes().toString().padStart(2, '0');
    let seconds: string = d.getSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  static convertToDateTime(dateString: string): string {
    const [date, time, period] = dateString.split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (period === 'PM' && hours !== 12) {
      hours += 12;
    } else if (period === 'AM' && hours === 12) {
      hours = 0;
    }
    return `${date}T${hours.toString().padStart(2, '0')}:${minutes}:00`;
  }

  static uniqueArray(array: any, key: any): any {
    const arr: Set<any> = new Set();
    return array.filter((item: { [x: string]: any; }) => {
      const value = item[key];
      if (arr.has(value)) {
        return false;
      } else {
        arr.add(value);
        return true;
      }
    });
  }

  static addDaysWithDate(date, days) {
    let currentDate = new Date(date);
    currentDate.setDate(currentDate.getDate() + days);
    let year = currentDate.getFullYear();
    let month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    let day = currentDate.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  static removeDuplicates(arr, key) {
    const seen = new Set();
    const uniqueArr = [];

    arr.forEach(item => {
      if (!seen.has(item[key])) {
        seen.add(item[key]);
        uniqueArr.push(item);
      }
    });
    return uniqueArr;
  }

  static filterArray(array, conditions) {
    return array.filter(item => {
      return Object.keys(conditions).every(key => {
        return item[key] === conditions[key];
      });
    });
  }

  static findCommonElements(arr1, arr2) {
    const set = new Set(arr1);
    return arr2.some(element => set.has(element));
  }
  static leave_status(status: any, leave: any) {
    if(status === "PENDING") return "Pending";
    else if(status === "APPROVED_BY_HOD" && leave.hr_status) return "Pending";
    else if(status === "APPROVED_BY_HOD" && !leave.hr_status) return "Approved";
    else if(status === "REJECTED_BY_HOD") return "Rejected";
    else if(status === "APPROVED_BY_HR" && leave.admin_status) return "Pending";
    else if(status === "APPROVED_BY_HR" && !leave.admin_status) return "Approved";
    else if(status === "REJECTED_BY_HR") return "Rejected";
    else if(status === "APPROVED_BY_ADMIN") return "Approved";
    else if(status === "REJECTED_BY_ADMIN") return "Rejected";
    else return "Rejected";
  }

  static getStatusTicketClass(status: any): string {
    const statusClasses = {
      'PENDING': 'text-indigo-800',
      'ON_HOLD': 'text-purple-800',
      'REJECTED': 'text-red-800',
      'RESOLVED': 'text-green-800',
    };
    return statusClasses[status] || '';
  }

  static ticketStatus(status: any): string {
    if(status === "PENDING") return "Pending";
    else if(status === "ON_HOLD") return "On Hold";
    else if(status === "REJECTED") return "Rejected";
    else if(status === "RESOLVED") return "Resolved";
    else return "";
  }

  static convertHourFormat(time: any): string {
    let [hours, minutes, seconds] = time.split(':').map(Number);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${hours}:${minutes < 10 ? '0' + minutes : minutes} ${ampm}`;
  }

}
